import React, { useLayoutEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loading } from '@/components/partials/loading/Loading';
import { useMutation } from '@tanstack/react-query';
import UnauthenticatedApi from '@/api/UnauthenticatedApi';

export const EmailConfirmation: React.FC = () => {
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();

	const verifyChangeEmailMutation = useMutation({
		mutationFn: UnauthenticatedApi.verifyChangeEmail,
		onSettled: () => {
			navigate('/');
		},
	});

	useLayoutEffect(() => {
		const hash = searchParams.get('token');
		if (!hash) return;

		verifyChangeEmailMutation.mutate(hash);
	}, []);

	return <Loading />;
};
